import SEO, { breadcrumbSchema } from "../components/SEO";
import PageHero from "../components/PageHero";
import CtaBand from "../components/CtaBand";
import { ServiceCard, SectionHead } from "../components/Cards";
import { SERVICES } from "../data/content";
import { SERVICES_HI } from "../data/hindi";
import { useLang } from "../i18n";
import { IMAGES } from "../data/site";

export default function Services() {
  const { lang, t } = useLang();
  const services = lang === "hi"
    ? SERVICES_HI.map((h) => ({ ...SERVICES.find((s) => s.slug === h.slug), ...h }))
    : SERVICES;

  return (
    <>
      <SEO
        title="Taxi Services in Jodhpur & Rajasthan"
        description="Local Jodhpur taxi, airport transfers, one-way & outstation cabs, Rajasthan sightseeing, corporate travel and tempo travellers — 12 taxi services from Blue City Taxi Jodhpur."
        path="/services"
        schemas={[breadcrumbSchema([{ name: "Home", path: "/" }, { name: "Services", path: "/services" }])]}
      />
      <PageHero
        title={t("pSvcTitle")}
        subtitle={t("pSvcSub")}
        image={IMAGES.highway}
        crumbs={[{ label: "Home", to: "/" }, { label: t("navServices") }]}
      />
      <section className="max-w-7xl mx-auto px-6 py-16">
        <SectionHead eyebrow={t("pSvcEyebrow")} title={t("pSvcHead")} />
        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((s, i) => <ServiceCard key={s.slug} s={s} i={i} />)}
        </div>
      </section>
      <CtaBand title={t("svcCtaTitle")} text={t("svcCtaText")} />
    </>
  );
}
